import { useState } from 'react';

import {
  BottomTabMenuItem,
  BottomTabNavbar,
  BottomTabSubMenu,
} from '@opositandopn/ui';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import {
  IoAnalyticsOutline,
  IoArrowDownCircleOutline,
  IoBookOutline,
  IoBookmarksOutline,
  IoCalculatorOutline,
  IoChatbubblesOutline,
  IoClipboardOutline,
  IoConstructOutline,
  IoDocumentTextOutline,
  IoEaselOutline,
  IoFileTrayFullOutline,
  IoFlashOutline,
  IoHomeOutline,
  IoLibraryOutline,
  IoPlayCircleOutline,
  IoReaderOutline,
  IoShapesOutline,
  IoShieldCheckmarkOutline,
  IoTodayOutline,
  IoTrashBinOutline,
  IoWarningOutline,
} from 'react-icons/io5';
import { PiBarbell } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

import { AdminWidthResolution } from '../../../constants/app';
import {
  APTITUDE_SUBJECT_ID,
  ENGLISH_SUBJECT_ID,
  THEORY_SUBJECT_ID,
} from '../../../constants/subjects';
import { useProfile } from '../../../context/ProfileContext';
import { usePwa } from '../../../context/PwaContext';
import { AssessmentSurveyBottomTabItem } from '../../../features/surveys/components/assessment-survey-bottom-tab-item/AssessmentSurveyBottomTabItem';
import { AssessmentSurveyView } from '../../../features/surveys/components/assessment-survey-view/AssessmentSurveyView';
import { Calculator } from '../../shared/calculator/Calculator';

import styles from './TabNavbar.module.scss';

function TabNavbar() {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const { width } = useWindowSize();
  const { prompt, standalone, promptToInstall } = usePwa();

  const [theorySurveyId, setTheorySurveyId] = useState<string>();
  const [aptitudeSurveyId, setAptitudeSurveyId] = useState<string>();

  const [showCalculator, setShowCalculator] = useState(false);
  const [showTheorySurvey, setShowTheorySurvey] = useState(false);
  const [showAptitudeSurvey, setShowAptitudeSurvey] = useState(false);

  return (
    <>
      <BottomTabNavbar className={styles['navbar']}>
        <BottomTabMenuItem
          icon={<IoHomeOutline />}
          title={'Inicio'}
          onClick={() => {
            navigate('/');
          }}
        />
        <BottomTabSubMenu icon={<IoLibraryOutline />} title={'Teoría'}>
          <BottomTabMenuItem
            icon={<IoBookOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/mc`);
            }}
          >
            Preguntas y simulacros
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoEaselOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/esquemas`);
            }}
          >
            Esquemas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoDocumentTextOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/recursos`);
            }}
          >
            Normativa
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoClipboardOutline />}
            onClick={() => {
              navigate(
                `/materia/${THEORY_SUBJECT_ID}/simulacros/mc/formativos`,
              );
            }}
          >
            Simulacros esenciales
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoFlashOutline />}
            onClick={() => {
              navigate(
                `/materia/${THEORY_SUBJECT_ID}/simulacros/mc/competitivos`,
              );
            }}
          >
            Simulacros competitivos
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoShieldCheckmarkOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/simulacros/mc/oficiales`);
            }}
          >
            Exámenes oficiales
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoBookmarksOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/preguntas/mc/guardadas`);
            }}
          >
            Preguntas guardadas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoTrashBinOutline />}
            onClick={() => {
              navigate(`/materia/${THEORY_SUBJECT_ID}/preguntas/mc/falladas`);
            }}
          >
            Preguntas falladas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoPlayCircleOutline />}
            onClick={() => {
              navigate(
                `/materia/${THEORY_SUBJECT_ID}/simulacros/mc/en-progreso`,
              );
            }}
          >
            Simulacros en progreso
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoFileTrayFullOutline />}
            onClick={() => {
              navigate(
                `/materia/${THEORY_SUBJECT_ID}/simulacros/mc/resultados`,
              );
            }}
          >
            Histórico de simulacros
          </BottomTabMenuItem>
          <AssessmentSurveyBottomTabItem
            subjectId={THEORY_SUBJECT_ID}
            onClick={(surveyId) => {
              setTheorySurveyId(surveyId);
              setShowTheorySurvey(true);
            }}
          >
            Encuesta de teoría
          </AssessmentSurveyBottomTabItem>
        </BottomTabSubMenu>
        <BottomTabSubMenu icon={<IoShapesOutline />} title={'Psicotécnicos'}>
          <BottomTabMenuItem
            icon={<IoBookOutline />}
            onClick={() => {
              navigate(`/materia/${APTITUDE_SUBJECT_ID}/mc`);
            }}
          >
            Preguntas y simulacros
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoClipboardOutline />}
            onClick={() => {
              navigate(
                `/materia/${APTITUDE_SUBJECT_ID}/simulacros/mc/formativos`,
              );
            }}
          >
            Simulacros esenciales
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoBookmarksOutline />}
            onClick={() => {
              navigate(
                `/materia/${APTITUDE_SUBJECT_ID}/preguntas/mc/guardadas`,
              );
            }}
          >
            Preguntas guardadas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoTrashBinOutline />}
            onClick={() => {
              navigate(`/materia/${APTITUDE_SUBJECT_ID}/preguntas/mc/falladas`);
            }}
          >
            Preguntas falladas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoPlayCircleOutline />}
            onClick={() => {
              navigate(
                `/materia/${APTITUDE_SUBJECT_ID}/simulacros/mc/en-progreso`,
              );
            }}
          >
            Simulacros en progreso
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoFileTrayFullOutline />}
            onClick={() => {
              navigate(
                `/materia/${APTITUDE_SUBJECT_ID}/simulacros/mc/resultados`,
              );
            }}
          >
            Histórico de simulacros
          </BottomTabMenuItem>
          <AssessmentSurveyBottomTabItem
            subjectId={APTITUDE_SUBJECT_ID}
            onClick={(surveyId) => {
              setAptitudeSurveyId(surveyId);
              setShowAptitudeSurvey(true);
            }}
          >
            Encuesta de psicotécnicos
          </AssessmentSurveyBottomTabItem>
        </BottomTabSubMenu>
        <BottomTabSubMenu icon={<IoChatbubblesOutline />} title={'Inglés'}>
          <BottomTabMenuItem
            icon={<IoBookOutline />}
            onClick={() => {
              navigate(`/materia/${ENGLISH_SUBJECT_ID}/mc`);
            }}
          >
            Preguntas y simulacros
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoBookmarksOutline />}
            onClick={() => {
              navigate(`/materia/${ENGLISH_SUBJECT_ID}/preguntas/mc/guardadas`);
            }}
          >
            Preguntas guardadas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoTrashBinOutline />}
            onClick={() => {
              navigate(`/materia/${ENGLISH_SUBJECT_ID}/preguntas/mc/falladas`);
            }}
          >
            Preguntas falladas
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoPlayCircleOutline />}
            onClick={() => {
              navigate(
                `/materia/${ENGLISH_SUBJECT_ID}/simulacros/mc/en-progreso`,
              );
            }}
          >
            Simulacros en progreso
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoFileTrayFullOutline />}
            onClick={() => {
              navigate(
                `/materia/${ENGLISH_SUBJECT_ID}/simulacros/mc/resultados`,
              );
            }}
          >
            Histórico de simulacros
          </BottomTabMenuItem>
        </BottomTabSubMenu>
        <BottomTabSubMenu icon={<PiBarbell />} title={'Pruebas físicas'}>
          <BottomTabMenuItem
            icon={<HiOutlineClipboardDocumentList />}
            onClick={() => {
              navigate('/pruebas-fisicas/planes');
            }}
          >
            Planes de entrenamiento
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoTodayOutline />}
            onClick={() => {
              navigate('/pruebas-fisicas/registro');
            }}
          >
            Registro diario
          </BottomTabMenuItem>
          <BottomTabMenuItem
            icon={<IoAnalyticsOutline />}
            onClick={() => {
              navigate('/pruebas-fisicas/progreso');
            }}
          >
            Progreso
          </BottomTabMenuItem>
        </BottomTabSubMenu>
        <BottomTabMenuItem
          icon={<IoAnalyticsOutline />}
          title={'Progreso'}
          onClick={() => {
            navigate('/progreso');
          }}
        />
        <BottomTabMenuItem
          icon={<IoCalculatorOutline />}
          title={'Calculadora'}
          onClick={() => {
            setShowCalculator(true);
          }}
        />
        {width > AdminWidthResolution && profile.role === 'admin' && (
          <BottomTabSubMenu
            icon={<IoConstructOutline />}
            title={'Administración'}
          >
            <BottomTabMenuItem
              icon={<HiOutlineClipboardDocumentList />}
              onClick={() => {
                navigate('/admin/planes-de-entrenamiento');
              }}
            >
              Planes de entrenamiento
            </BottomTabMenuItem>
            <BottomTabMenuItem
              icon={<IoEaselOutline />}
              onClick={() => {
                navigate('/admin/esquemas');
              }}
            >
              Esquemas
            </BottomTabMenuItem>
            <BottomTabMenuItem
              icon={<IoClipboardOutline />}
              onClick={() => {
                navigate('/admin/simulacros');
              }}
            >
              Simulacros
            </BottomTabMenuItem>
            <BottomTabMenuItem
              icon={<IoReaderOutline />}
              onClick={() => {
                navigate('/admin/preguntas');
              }}
            >
              Preguntas
            </BottomTabMenuItem>
            <BottomTabMenuItem
              icon={<IoWarningOutline />}
              onClick={() => {
                navigate('/admin/reportes');
              }}
            >
              Reportes
            </BottomTabMenuItem>
          </BottomTabSubMenu>
        )}
        {prompt != null && !standalone && (
          <BottomTabMenuItem
            icon={<IoArrowDownCircleOutline />}
            title={'Instalar app'}
            onClick={promptToInstall}
            className={styles['install']}
          />
        )}
      </BottomTabNavbar>
      <Calculator
        open={showCalculator}
        onClose={() => setShowCalculator(false)}
      />
      {theorySurveyId && (
        <AssessmentSurveyView
          subjectId={THEORY_SUBJECT_ID}
          surveyId={theorySurveyId}
          open={showTheorySurvey}
          onClose={() => setShowTheorySurvey(false)}
        />
      )}
      {aptitudeSurveyId && (
        <AssessmentSurveyView
          subjectId={APTITUDE_SUBJECT_ID}
          surveyId={aptitudeSurveyId}
          open={showAptitudeSurvey}
          onClose={() => setShowAptitudeSurvey(false)}
        />
      )}
    </>
  );
}

export { TabNavbar };
